<template>
  <div id="menuListContainer" :style="cssProps">
    <div class="mainMenuContainer">
      <div
          v-for="(item, index) in menuData"
          v-bind:class="getItemClass(item)"
          :key="index"
          @click="onClickMenu(item)"
      >
        <div
            v-if="'subItems' in item"
            class="subMenuContainer"
        >
          <div class="item subItemTitle">{{item.name}}</div>
          <div
              v-for="(subItem, index2) in item.subItems"
              class="item subItem"
              :key="index2"
              @click="onClickMenu(subItem)"
          >
            <div>{{subItem.name}}</div>
          </div>
        </div>
        <div v-else>
          {{item.name}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuListComponent",
  props: ['menuData', 'top', 'left'],
  data() {
    return {
    }
  },
  computed: {
    cssProps() {
      return `top: ${this.top || 0}px; left: ${this.left || 0}px`;
    }
  },
  methods: {
    getItemClass(item) {
      return 'subItems' in item ? '' : 'item';
    },
    onClickMenu(item) {
      if ('subItems' in item) {
        return;
      }

      this.$router.push(`/hyundai/${item.url.replace('/','%2F')}`);
    }
  }
}
</script>

<style scoped>
#menuListContainer {
  position: absolute;
  top: 0;
  left: 0;
  background: #333333;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 0;
  margin: 0;

  width: 160px;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.6px;
  color: #FFFFFF;
  overflow: hidden;
}

.item {
  width: 160px;
  height: 32px;
  margin: 8px 0;
  padding-left: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  line-height: 16px;
  /*border-radius: 10px;*/
}

.item:hover {
  background: #424242;
  cursor: pointer;
}

.mainMenuContainer {
  list-style: none;
}

.subMenuContainer {

}

.subItem {
  font-size: 14px;
  line-height: 14px;
  letter-spacing: -0.6px;


}

.subItem::before {
  content: '';
  background-color: #FFFFFF;
  height: 3.5px;
  width: 3.5px;
  border-radius: 50%;
  display: inline-block;
  margin: 10px;

}

.subItemTitle:hover {
  background: #333333;
  cursor: default;
}

</style>
